import "../styles/Footer.css";
import {
  AiFillGithub,
  AiFillLinkedin,
  AiFillBehanceCircle,
  AiFillInstagram,
} from "react-icons/ai";

function Footer() {
  return (
    <div className="footer">
      <div className="contact__link">
        <div className="link">
          <a
            href="https://www.linkedin.com/in/artemis-dev-6a2aa1215/"
            target="_blank"
            rel="noreferrer"
          >
            <i>
              <AiFillLinkedin />
            </i>
          </a>
        </div>
        <div className="link">
          <a href="https://github.com/Nodarra" target="_blank" rel="noreferrer">
            <i>
              <AiFillGithub />
            </i>
          </a>
        </div>
        <div className="link">
          <a
            href="https://www.instagram.com/artemis_dev/"
            target="_blank"
            rel="noreferrer"
          >
            <i>
              <AiFillInstagram />
            </i>
          </a>
        </div>
        <div className="link">
          <a
            href="https://www.behance.net/merisstupar"
            target="_blank"
            rel="noreferrer"
          >
            <i>
              <AiFillBehanceCircle />
            </i>
          </a>
        </div>
      </div>
      <p>&#169; 2021 copyright by Artemis</p>
    </div>
  );
}

export default Footer;
